import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, of } from "rxjs";
import { CustomerService } from "../services/customer.service";
import { Customer } from "../../shared/models/customer.interface";
import { catchError, finalize } from "rxjs/operators";
import { CustomerFilter } from "../models/customer.filter";

export class CustomersDataSource implements DataSource<Customer> {
  private customersSubject = new BehaviorSubject<Customer[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private customerService: CustomerService) { }

  connect(collectionViewer: CollectionViewer): Observable<Customer[]> {
    return this.customersSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.customersSubject.complete();
    this.loadingSubject.complete();
  }

  loadCustomers(filter: CustomerFilter,
    sortColumn = 'customerName', sortDirection = 'asc', pageIndex = 0) {

    this.loadingSubject.next(true);

    this.customerService.getList(filter, sortColumn, sortDirection, pageIndex).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(lessons => this.customersSubject.next(lessons));
  }
}
